module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-account-status"
  }, _vm._l((_vm.statuses), function(status) {
    return _c('div', {
      staticClass: "status"
    }, [_c('div', {
      staticClass: "stats"
    }, [_c('i', {
      staticClass: "fa fa-2x",
      class: _vm.getStatusClass(status),
      on: {
        "click": function($event) {
          return _vm.$emit('input', status)
        }
      }
    }), _c('p', {
      staticClass: "no-wrap"
    }, [_vm._v(_vm._s(status.replace(/_status|_method/gi, '')))])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ed83c8d0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/AccountStatus.vue
// module id = 2738
// module chunks = 1